import { useState } from 'react';
import { AccordionSection } from '@/shared/ui';
import { mockSections } from '@/data/mockData';
import { Section } from '@/data/mockData';
import { useInitLayoutQuery } from '@/entities/layout';
import { useAppSelector } from '@/shared/lib';

const HomePage = () => {
  // In a real app, we would fetch this data
  const [sections] = useState<Section[]>(mockSections);

  const { data, isLoading } = useInitLayoutQuery();
  console.log(data);

  return (
    <>
      {sections.map((section) => (
        <AccordionSection key={section.id} section={section} />
      ))}
    </>
  );
};

export default HomePage;
